import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MenuItemComponent } from './menu-item.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: '[menuItemLight]',
  styleUrls: ['./menu-item-light.component.scss'],
  templateUrl: './menu-item.component.html',
})
export class MenuItemLightComponent extends MenuItemComponent {}
